import { IAudioBridgeResponse } from './connections.dao';

abstract class IAudioBridgeDAO {
    public abstract getAudioBridgeDetails(params: IAudioBridgeRequestParams): Promise<IAudioBridgeResponse>;
}

interface IAudioBridgeRequestParams {
    audioBridgeId: string;
}

export {
    IAudioBridgeDAO,
    IAudioBridgeRequestParams
};